// Gemeinsame Bausteine der Stammdaten-Verträge. Konvention für alle Änderungs-Verträge dieses Moduls:
//   anlegen   Pflichtfelder + optionale Felder mit Standardwert
//   ändern    { id, expectedVersion?, …nur die Felder, die sich ändern }   undefined = unverändert, null = leeren
//   sperren   <gegenstand>.deactivate (mit Vorschau) / <gegenstand>.reactivate – gelöscht wird nichts, was je
//             verwendet wurde
import { zId } from '@shared/ids'
import { z } from 'zod'

/** Pflichttext: beschnitten, nicht leer. */
export const zText = (max: number) => z.string().trim().min(1).max(max)

/** Freiwilliger Text: '' gilt als „nicht angegeben“ (null); undefined bleibt undefined (= unverändert beim Ändern). */
export const zOptionalText = (max: number) =>
  z
    .string()
    .trim()
    .max(max)
    .nullish()
    .transform((value) => (value === '' ? null : value))

export const zOptionalId = zId.nullish()

/** Kalendertag 'YYYY-MM-DD' (Europe/Berlin). */
export const zDay = z.iso.date({ error: 'Bitte ein gültiges Datum eingeben.' })

/** Zeitpunkt als ISO-Zeichenkette (UTC). */
export const zTimestamp = z.string()

/** Menge in Tausendstel der Basiseinheit, nicht negativ. */
export const zQtyAmount = z.int({ error: 'Bitte eine Menge eingeben.' }).min(0, { error: 'Die Menge darf nicht negativ sein.' })

/** Geld in Cent, nicht negativ. */
export const zCentsAmount = z.int({ error: 'Bitte einen Betrag eingeben.' }).min(0, { error: 'Der Betrag darf nicht negativ sein.' })

/** Prozentsatz in Basispunkten (1900 = 19 %). */
export const zBasisPoints = z
  .int({ error: 'Bitte einen Prozentsatz eingeben.' })
  .min(0, { error: 'Der Prozentsatz darf nicht negativ sein.' })
  .max(10_000, { error: 'Mehr als 100 % sind nicht möglich.' })

export const zDays = z.int({ error: 'Bitte eine Zahl von Tagen eingeben.' }).min(0, { error: 'Bitte eine Zahl ab 0 eingeben.' }).max(3650)

/** Ergebnis jeder Änderung an einem Stammdatensatz. */
export const zSaved = z.object({ id: zId, version: z.int() })

/** Eingabe von <gegenstand>.get */
export const zById = z.strictObject({ id: zId })

/** Eingabe von <gegenstand>.deactivate / reactivate */
export const zToggle = z.strictObject({
  id: zId,
  /** Begründung für den Verlauf (frei) */
  reason: zOptionalText(300),
})

/** Version für den Schreibschutz gegen überholte Stände: weicht sie ab, antwortet der Server mit CONFLICT. */
export const zExpectedVersion = z.int().positive().optional()

/** Kurzform einer Einheit, wie Listen und Auswahlfelder sie brauchen. */
export const zUnitRef = z.object({ id: zId, code: z.string(), short: z.string(), name: z.string(), decimals: z.int() })

export const zActor = z.object({ id: zId, displayName: z.string() }).nullable()
